// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var LabelTranscriptRequest_CallCategory;
(function (LabelTranscriptRequest_CallCategory) {
    LabelTranscriptRequest_CallCategory["UNKNOWN_CALL_CATEGORY"] = "UNKNOWN_CALL_CATEGORY";
    LabelTranscriptRequest_CallCategory["EMERGENCY"] = "EMERGENCY";
    LabelTranscriptRequest_CallCategory["SCHEDULING"] = "SCHEDULING";
    LabelTranscriptRequest_CallCategory["RESCHEDULE"] = "RESCHEDULE";
    LabelTranscriptRequest_CallCategory["CANCELLATION"] = "CANCELLATION";
    LabelTranscriptRequest_CallCategory["NEW_PATIENT"] = "NEW_PATIENT";
    LabelTranscriptRequest_CallCategory["PRICING"] = "PRICING";
    LabelTranscriptRequest_CallCategory["BILLING"] = "BILLING";
    LabelTranscriptRequest_CallCategory["VENDOR"] = "VENDOR";
    LabelTranscriptRequest_CallCategory["MEDICATION"] = "MEDICATION";
    LabelTranscriptRequest_CallCategory["COMPLAINT"] = "COMPLAINT";
    LabelTranscriptRequest_CallCategory["OTHER"] = "OTHER";
})(LabelTranscriptRequest_CallCategory || (LabelTranscriptRequest_CallCategory = {}));
export var LabelTranscriptRequest_CallCategory_index;
(function (LabelTranscriptRequest_CallCategory_index) {
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["UNKNOWN_CALL_CATEGORY"] = 0] = "UNKNOWN_CALL_CATEGORY";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["EMERGENCY"] = 1] = "EMERGENCY";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["SCHEDULING"] = 2] = "SCHEDULING";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["RESCHEDULE"] = 3] = "RESCHEDULE";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["CANCELLATION"] = 4] = "CANCELLATION";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["NEW_PATIENT"] = 5] = "NEW_PATIENT";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["PRICING"] = 6] = "PRICING";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["BILLING"] = 7] = "BILLING";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["VENDOR"] = 8] = "VENDOR";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["MEDICATION"] = 9] = "MEDICATION";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["COMPLAINT"] = 10] = "COMPLAINT";
    LabelTranscriptRequest_CallCategory_index[LabelTranscriptRequest_CallCategory_index["OTHER"] = 11] = "OTHER";
})(LabelTranscriptRequest_CallCategory_index || (LabelTranscriptRequest_CallCategory_index = {}));
export var LabelTranscriptRequest_Sentiment;
(function (LabelTranscriptRequest_Sentiment) {
    LabelTranscriptRequest_Sentiment["SENTIMENT_UNKNOWN"] = "SENTIMENT_UNKNOWN";
    LabelTranscriptRequest_Sentiment["STRONGLY_NEGATIVE"] = "STRONGLY_NEGATIVE";
    LabelTranscriptRequest_Sentiment["NEGATIVE"] = "NEGATIVE";
    LabelTranscriptRequest_Sentiment["NEUTRAL"] = "NEUTRAL";
    LabelTranscriptRequest_Sentiment["POSITIVE"] = "POSITIVE";
    LabelTranscriptRequest_Sentiment["STRONGLY_POSITIVE"] = "STRONGLY_POSITIVE";
})(LabelTranscriptRequest_Sentiment || (LabelTranscriptRequest_Sentiment = {}));
export var LabelTranscriptRequest_Sentiment_index;
(function (LabelTranscriptRequest_Sentiment_index) {
    LabelTranscriptRequest_Sentiment_index[LabelTranscriptRequest_Sentiment_index["SENTIMENT_UNKNOWN"] = 0] = "SENTIMENT_UNKNOWN";
    LabelTranscriptRequest_Sentiment_index[LabelTranscriptRequest_Sentiment_index["STRONGLY_NEGATIVE"] = 1] = "STRONGLY_NEGATIVE";
    LabelTranscriptRequest_Sentiment_index[LabelTranscriptRequest_Sentiment_index["NEGATIVE"] = 2] = "NEGATIVE";
    LabelTranscriptRequest_Sentiment_index[LabelTranscriptRequest_Sentiment_index["NEUTRAL"] = 3] = "NEUTRAL";
    LabelTranscriptRequest_Sentiment_index[LabelTranscriptRequest_Sentiment_index["POSITIVE"] = 4] = "POSITIVE";
    LabelTranscriptRequest_Sentiment_index[LabelTranscriptRequest_Sentiment_index["STRONGLY_POSITIVE"] = 5] = "STRONGLY_POSITIVE";
})(LabelTranscriptRequest_Sentiment_index || (LabelTranscriptRequest_Sentiment_index = {}));
export var LabelTranscriptRequest_AppointmentType;
(function (LabelTranscriptRequest_AppointmentType) {
    LabelTranscriptRequest_AppointmentType["UNKNOWN_APPOINTMENT_TYPE"] = "UNKNOWN_APPOINTMENT_TYPE";
    LabelTranscriptRequest_AppointmentType["COSMETIC"] = "COSMETIC";
    LabelTranscriptRequest_AppointmentType["ORTHODONTICS"] = "ORTHODONTICS";
    LabelTranscriptRequest_AppointmentType["SURGERY"] = "SURGERY";
    LabelTranscriptRequest_AppointmentType["HYGIENE"] = "HYGIENE";
    LabelTranscriptRequest_AppointmentType["RESTORATIVE"] = "RESTORATIVE";
    LabelTranscriptRequest_AppointmentType["EMERGENCY_CARE"] = "EMERGENCY_CARE";
    LabelTranscriptRequest_AppointmentType["IMAGING"] = "IMAGING";
    LabelTranscriptRequest_AppointmentType["OTHER_APPT"] = "OTHER_APPT";
})(LabelTranscriptRequest_AppointmentType || (LabelTranscriptRequest_AppointmentType = {}));
export var LabelTranscriptRequest_AppointmentType_index;
(function (LabelTranscriptRequest_AppointmentType_index) {
    LabelTranscriptRequest_AppointmentType_index[LabelTranscriptRequest_AppointmentType_index["UNKNOWN_APPOINTMENT_TYPE"] = 0] = "UNKNOWN_APPOINTMENT_TYPE";
    LabelTranscriptRequest_AppointmentType_index[LabelTranscriptRequest_AppointmentType_index["COSMETIC"] = 1] = "COSMETIC";
    LabelTranscriptRequest_AppointmentType_index[LabelTranscriptRequest_AppointmentType_index["ORTHODONTICS"] = 2] = "ORTHODONTICS";
    LabelTranscriptRequest_AppointmentType_index[LabelTranscriptRequest_AppointmentType_index["SURGERY"] = 3] = "SURGERY";
    LabelTranscriptRequest_AppointmentType_index[LabelTranscriptRequest_AppointmentType_index["HYGIENE"] = 4] = "HYGIENE";
    LabelTranscriptRequest_AppointmentType_index[LabelTranscriptRequest_AppointmentType_index["RESTORATIVE"] = 5] = "RESTORATIVE";
    LabelTranscriptRequest_AppointmentType_index[LabelTranscriptRequest_AppointmentType_index["EMERGENCY_CARE"] = 6] = "EMERGENCY_CARE";
    LabelTranscriptRequest_AppointmentType_index[LabelTranscriptRequest_AppointmentType_index["IMAGING"] = 7] = "IMAGING";
    LabelTranscriptRequest_AppointmentType_index[LabelTranscriptRequest_AppointmentType_index["OTHER_APPT"] = 8] = "OTHER_APPT";
})(LabelTranscriptRequest_AppointmentType_index || (LabelTranscriptRequest_AppointmentType_index = {}));
export const CallIntelligenceService = {
    GetTranscript(fn, req) {
        return fn(`/data-labeling/call-intelligence/v1/transcripts?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    LabelTranscript(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/data-labeling/call-intelligence/v1/transcripts/${req["id"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetLeaderboard(fn, req) {
        return fn(`/data-labeling/call-intelligence/v1/leaderboard?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    MarkTranscriptInvalid(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/data-labeling/call-intelligence/v1/transcripts/${req["id"]}/invalid`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
